'use client';

import { TreasurySectionValueDigit } from './TreasurySectionValueDigit';
import { TreasurySectionValueProps } from './TreasurySectionValue.types';
import { flex, text } from '@onbeam/business-styled-system/patterns';
import { isNumber } from '@onbeam/utils';
import { motion, useInView } from 'motion/react';
import { useRef } from 'react';
import { css } from '@onbeam/business-styled-system/css';

export const TreasurySectionValue = ({
  children,
}: TreasurySectionValueProps) => {
  const containerRef = useRef<HTMLHeadingElement>(null);
  const isInView = useInView(containerRef, { amount: 'all', once: true });
  const formatted = Math.round(children).toLocaleString();
  const characters = formatted.split('');

  return (
    <motion.h3
      ref={containerRef}
      className={flex({
        align: 'end',
        zIndex: 2,
        textStyle: 'subtitle-lg',
        '@media(min-width: 360px)': {
          textStyle: 'subtitle-xl',
        },
        sm: {
          textStyle: 'headline-lg',
        },
      })}
      initial={{ opacity: 0 }}
      animate={{ opacity: isInView ? 1 : 0 }}
    >
      <span
        className={text({
          style: 'subtitle-md',
          mb: '1',
          sm: {
            textStyle: 'subtitle-lg',
          },
        })}
      >
        $
      </span>
      {isInView &&
        characters.map((character, index) =>
          isNumber(Number(character)) ? (
            <TreasurySectionValueDigit
              key={index}
              value={Number(character)}
              index={index}
            />
          ) : (
            <span
              key={index}
              className={css({
                '@media(max-width: 360px)': {
                  mb: '1',
                },
              })}
            >
              {character}
            </span>
          ),
        )}
    </motion.h3>
  );
};
